export default __webpack_public_path__ + "static/media/grafema_the-essence-collective_01.7a43c97d.jpg";